import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, type DialogProps, DialogTitle } from 'base-ui'

import { ExperimentOdsVideoConsultationWrapper } from '../../ods/components/ExperimentOdsVideoConsultationWrapper'

import { ProductPageOdsDialogContent } from './ProductPageOdsDialogContent'

type ProductPageOdsDialogProps = Pick<DialogProps, 'onClose' | 'open'>

export const ProductPageOdsDialog: FC<ProductPageOdsDialogProps> = ({
  onClose,
  open,
}) => (
  <Dialog
    onClose={onClose}
    open={open}
    slotProps={{
      dialog: {
        className: 'tablet:w-[40.25rem]',
      },
    }}
  >
    <DialogTitle onClose={onClose}>
      <ExperimentOdsVideoConsultationWrapper
        childVideoConsultationV1={
          <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.title" />
        }
        childZavaProvider={
          <FormattedMessage id="pdp.buyboxwithvariants.odsModal.title" />
        }
      />
    </DialogTitle>
    <DialogContent>
      <ExperimentOdsVideoConsultationWrapper
        childVideoConsultationV1={<ProductPageOdsDialogContent />}
        childZavaProvider={<ProductPageOdsDialogContent />}
      />
    </DialogContent>
  </Dialog>
)
